import { FC, useCallback, useEffect, useState } from 'react';
import { useInterval } from 'usehooks-ts';

import type { DailyBlotterState } from './DailyBlotter.connect';
import { connectDailyBlotter } from './DailyBlotter.connect';
import { DailyBlotterPagination } from './table/Pagination.connect';
import { DailyBlotterTable } from './table/Table';
import { DailyBlotterToolBar } from './toolBar/ToolBar';

export const Component: FC<DailyBlotterState> = ({
  isDailyBlotterTabActive,
  onQuoteRequested,
  page,
  onColumnsRequested,
}) => {
  const [isNotFirstLoad, setIsNotFirstLoad] = useState<boolean>(false);

  const reloadQuotes = useCallback(() => {
    if (isDailyBlotterTabActive) {
      onQuoteRequested(page);
    }
  }, [isDailyBlotterTabActive, onQuoteRequested, page]);

  useInterval(reloadQuotes, 30000);

  useEffect(() => {
    if (!isNotFirstLoad) {
      onColumnsRequested();
      setIsNotFirstLoad(true);
    }
    reloadQuotes();
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps Do not rerun this effect when onColumnsRequested changes
  }, [reloadQuotes, isNotFirstLoad]);

  return (
    <div data-e2e="daily-blotter">
      <DailyBlotterToolBar />
      <DailyBlotterTable />
      <DailyBlotterPagination />
    </div>
  );
};

export const DailyBlotter = connectDailyBlotter(Component);

Component.displayName = 'DailyBlotter';
